import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import GaugeComponent from 'react-gauge-component'

/**
 * 반원 게이지.
 *
 * targetValue 가 없으면(측정값이 없거나 환산할 수 없는 경우) 게이지를 그리지 않고
 * '미측정'으로 표시한다. 예전에는 그대로 넘겨서 바늘이 0 이나 한가운데(정상 구간)에
 * 놓였는데, 한 번도 측정하지 않은 사용자에게 '정상'으로 읽히는 문제가 있었다.
 * 값 판정은 호출부(util.getPercentValueForGauge 등)가 하고, 여기서는 표시만 나눈다.
 */
export default function GaugeChart(props: any) {

  const value = props.targetValue;
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return (
      <Box sx={{ width: 120, height: 70, mt: '-10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography sx={{ fontSize: 13, color: '#aaa' }}>미측정</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{
      '& svg' : {width:120, height:70, mt:'-10px'},
      '& .tick-value' : {display:'none'},
      '& .tick-line' : {display:'none'}
      
    }}>
      <GaugeComponent
        type="semicircle"
        arc={{
          colorArray: [ '#ffe000','#5BE12C','#ff0000',],
          padding: 0.02,
          width: 0.2,
          subArcs: [
            {
              limit: 30,
              color: '#EA4228',
              showTick: false,
            },
            {
              limit: 70,
              color: '#F5CD19',
              showTick: false,
            },
            {
              limit: 100,
              color: '#5BE12C',
              showTick: false,
            },
            
          ]
        }}
        
        labels={{
          valueLabel: {
            hide:true
            
          },
        }}
        
        value={Number(value)}
    
        pointer={{
          elastic: true,
          animationDelay: 0
        }}
      />
    </Box>
  );
}